import { useFind } from 'api/APIHooks';
import { get } from 'lodash';
import { isTypeSerializable } from 'api/utils/isTypeSerializable';

const useTimelineEvents = (recordType, recordId) => {
  if (!isTypeSerializable(recordType)) throw new Error('Invalid RecordType for useTimelineEvents');
  const recordParams = {
    [`${recordType}_id`]: recordId,
  };

  const { data: timelineEventsData } = useFind(
    `${recordType}s/${recordId}/timeline_event`,
    recordParams,
    {
      queryConfig: {
        enabled: !!recordId,
        placeholderData: undefined,
      },
    },
  );
  const timelineEvents = get(timelineEventsData, 'data.data', []);

  return timelineEvents;
};

export default useTimelineEvents;
